/* NUCU トップページ改装 (2026-09-15) 共通スクリプト: ヒーローのスライド、色スウォッチの切替 */
(function () {
  function initHero(hero) {
    if (hero.dataset.nrInit) return;
    hero.dataset.nrInit = '1';
    var slides = hero.querySelectorAll('.nr-slide');
    var dots = hero.querySelectorAll('.nr-dots button');
    var i = 0, t = null;
    var speed = parseInt(hero.dataset.autoplay || '0', 10) * 1000;
    if (slides.length < 2) return;
    function go(n) {
      slides[i].classList.remove('on'); if (dots[i]) dots[i].classList.remove('on');
      i = n;
      slides[i].classList.add('on'); if (dots[i]) dots[i].classList.add('on');
    }
    function loop() { if (speed > 0) t = setInterval(function () { go((i + 1) % slides.length); }, speed); }
    dots.forEach(function (b, n) {
      b.addEventListener('click', function () { clearInterval(t); go(n); loop(); });
    });
    loop();
  }

  function initCard(card) {
    if (card.dataset.nrInit) return;
    card.dataset.nrInit = '1';
    var img = card.querySelector('.nr-card__media img');
    var nameA = card.querySelector('.nr-card__name a');
    var links = card.querySelectorAll('a[data-nr-link]');
    var price = card.querySelector('.nr-card__price');
    var stock = card.querySelector('.nr-stock');
    var badges = card.querySelector('.nr-card__badges');
    card.querySelectorAll('.nr-sw button').forEach(function (b) {
      b.addEventListener('click', function () {
        card.querySelectorAll('.nr-sw button').forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        var d = b.dataset;
        if (d.img && img) {
          img.style.opacity = 0;
          setTimeout(function () {
            img.removeAttribute('srcset'); img.removeAttribute('sizes');
            img.src = d.img; img.alt = d.name || '';
            img.style.opacity = 1;
          }, 170);
        }
        if (nameA && d.name) nameA.textContent = d.name;
        if (d.url) links.forEach(function (a) { a.href = d.url; });
        if (d.url) card.querySelectorAll('[data-nr-qv]').forEach(function (b) { b.setAttribute('data-product-url', d.url); });
        if (price && d.price) price.innerHTML = d.price;
        if (stock) stock.textContent = d.stock || '';
        if (badges) {
          badges.innerHTML = '';
          if (d.sold === 'true') badges.insertAdjacentHTML('beforeend', '<span class="nr-bdg nr-bdg--sold">SOLD OUT</span>');
          else if (d.low === 'true') badges.insertAdjacentHTML('beforeend', '<span class="nr-bdg nr-bdg--low">LOW STOCK</span>');
          if (d.isnew === 'true') badges.insertAdjacentHTML('beforeend', '<span class="nr-bdg">NEW</span>');
        }
        card.classList.toggle('is-sold', d.sold === 'true');
      });
    });
  }

  function init(root) {
    (root || document).querySelectorAll('.nr-hero').forEach(initHero);
    (root || document).querySelectorAll('.nr-card').forEach(initCard);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
